import { createAction, props } from '@ngrx/store';
import { userInfoEntity } from './user-info.models';

export const loadUserInfo = createAction('[User Info] Load User Info', props<{ language: string }>());

export const loadUserInfoSuccess = createAction(
  '[User Info] Load User Info Success',
  props<{ userInfo: userInfoEntity }>()
);

export const loadUserInfoFailure = createAction('[User Info] Load User Info Failure', props<{ error: any }>());

export const setUserInfo = createAction('[User Info] Set User Info', props<{ isSet: boolean }>());

export const deleteLastViewedDocument = createAction(
  '[User Info] Delete Last Viewed Document',
  props<{ documentId: number }>()
);

export const deleteLastViewedDocumentSuccess = createAction(
  '[User Info] Delete Last Viewed Document Success',
  props<{ response: any }>()
);

export const deleteLastViewedDocumentFailure = createAction(
  '[User Info] Delete Last Viewed Document Failure',
  props<{ error: any }>()
);
